import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import AdvertGallery from '@app/page/advertise/gallery';
import AdvertiseGuidelines from '@app/page/advertise/guidelines';
import AdvertiseHome from '@app/page/advertise/home';
import Store from '@app/store';

import ContactSales from '@component/form/contactsales';
import Icon from '@component/icon';

import { DODGER_BLUE } from '@constant/colors';
import mobileNavigation from '@component/navigation/menu/mobile';
import desktopNavigation from '@component/navigation/menu/desktop';

export default {
  getItems() {
    const { user, account } = Store.getState();

    if (Browser.isMobile) {
      return mobileNavigation.create(user);
    }
    return desktopNavigation.create(user, account);
  },

  getAdvertisePageItems() {
    const downloadIcon = (
      <Icon
        type="DownloadSmall"
        className="verticalnav__icon"
        color={DODGER_BLUE}
      />
    );

    const items = [
      {
        href: '/advertise',
        label: I18n.t('page.advertise.nav.home'),
        component: AdvertiseHome,
      },
      {
        href: '/advertise/guidelines',
        label: I18n.t('page.advertise.nav.guidelines'),
        component: AdvertiseGuidelines,
        hiddenOnMobile: true,
      },
      {
        href: '/advertise/gallery',
        label: I18n.t('page.advertise.nav.gallery'),
        component: AdvertGallery,
        hiddenOnMobile: true,
      },
      {
        href: '/advertise/contact',
        label: I18n.t('page.advertise.nav.contact_1905'),
        component: ContactSales,
        className: 'verticalnav__item--is-without-separator',
      },
      {
        label: I18n.t('page.advertise.nav.resources'),
        className: 'verticalnav__item--is-without-separator',
      },
      {
        href: '/docs/advertising/wetransfer-safearea.zip',
        label: I18n.t('page.advertise.nav.download_mockup'),
        icon: downloadIcon,
        external: true,
        hiddenOnMobile: true,
      },
      {
        href: '/docs/advertising/wetransfer-html5api.zip',
        label: I18n.t('page.advertise.nav.download_dev_toolkit'),
        icon: downloadIcon,
        external: true,
        hiddenOnMobile: true,
        className: 'verticalnav__item--is-without-separator',
      },
    ];

    return items;
  },

  getBackButtonItem(name, path) {
    return [{ name, path, backButton: true }];
  },

  getNotifications() {
    return {
      onboarding: { name: 'onboarding_success' },
      signin: { name: 'already_signed_in' },
    };
  },
};
